<template>
  <div>
    <div class="flex flex-col py-4">
      <div class v-if="!error">
        <div class="align-middle inline-block min-w-full overflow-hidden border border-gray-400">
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                >Nr</th>
                <th
                  class="px-2 py-2 border w-2/6 border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                >EMRI</th>
                <th
                  class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >KOMENT</th>
                <th
                  class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >DITET</th>
                <th
                  class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >TIME</th>
                 <th
                  class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >ZV3</th>
                <th
                  class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >USER</th>
                <th class="px-2 py-2 border w-1 border-gray-400 bg-gray-50"></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="(weeklyTask, index) in weeklyTasks" :key="index.id">
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ index + 1 }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >
                  <span
                    :class="
                      weeklyTask.name.substring(0, 3) === '!!!'
                        ? 'text-red-600 font-semibold'
                        : ''
                    "
                  >{{ weeklyTask.name }}</span>
                </td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ weeklyTask.comment }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >
                  <span v-for="day in weeklyTask.days" :key="day.id">
                    <div
                      class="ml-4 text-xs inline-flex items-center font-bold leading-sm uppercase px-2 py-1 my-1 bg-green-200 text-green-700 rounded-full"
                    >{{ day.name }}</div>
                  </span>
                </td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ weeklyTask.time }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ weeklyTask.zv3 }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ weeklyTask.user }}</td>
                <td
                  class="px-2 py-2 whitespace-no-wrap text-right border border-gray-400 text-sm leading-5 font-medium"
                >
                  <router-link
                    :to="{
                      name: 'edit-weekly-tasks',
                      params: { id: weeklyTask.id },
                    }"
                  >
                    <span
                      class="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                    >Ndrysho</span>
                  </router-link>
                  <span class="ml-2">
                    <button
                      @click="deleteTask(weeklyTask.id)"
                      class="text-indigo-600 font-semibold hover:text-indigo-900 focus:outline-none focus:underline"
                    >Fshije</button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else>
        <p class="text-red-700 py-8">Perfundoj detyrat e dites se djeshme!!</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      weeklyTasks: [],
      id: this.$route.params.id,
      error: ""
    };
  },
  created() {
    this.getWeeklyTasks();
  },
  methods: {
    getWeeklyTasks() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/detyrat-javore`)
        .then(response => {
          // console.log(response.data);
          this.weeklyTasks = response.data;
          console.log(this.weeklyTasks);
        })
        .catch(error => console.log(error));
    },
    deleteTask(id) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (confirm("A jeni te sigurt qe deshironi ta fshini detyren?")) {
        axios
          .delete(`${process.env.VUE_APP_API}/excel/detyrat-javore/${id}`)
          .then(() => {
            this.$notify({
              group: "address",
              title: "Detyra",
              text: "Detyra u fshi"
            });

            const index = this.weeklyTasks.findIndex(wt => wt.id === id);
            if (~index) this.weeklyTasks.splice(index, 1);
          })
          .catch(error => console.log(error));
      }
    }
  }
};
</script>

<style></style>
